export default __webpack_public_path__ + "static/media/close.af7dbff8.svg";